export enum TokenType {
  ACCESS_TOKEN = 'at',
  REFRESH_TOKEN = 'rt',
}
